<script lang="ts">
	import { createEventDispatcher } from 'svelte'

	export let widthDividers = false
	export let active = true
	export let disabled = false
	export let tooltipText = ''

	let linkClass = 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
	if (!active || disabled) linkClass = 'text-gray-300 cursor-not-allowed'

	const dispatch = createEventDispatcher()

	function doAction(event: Event) {
		event.preventDefault()
		event.stopPropagation()

		if (!active || disabled) return

		dispatch('click', event)
	}
</script>

{#if active}
	{#if widthDividers}
		<div class="py-1" role="none" data-tooltip={tooltipText}>
			<a
				href={''}
				on:click={(e) => doAction(e)}
				class="{linkClass} group flex items-center px-4 py-2 text-sm gap-2"
				role="menuitem"
				tabindex="-1"
				id="menu-item-0"
				{...$$restProps}
			>
				<slot />
			</a>
		</div>
	{:else}
		<a
			href={''}
			on:click={(e) => doAction(e)}
			class="{linkClass} group flex items-center px-4 py-2 text-sm gap-2"
			role="menuitem"
			tabindex="-1"
			id="menu-item-0"
			{...$$restProps}
		>
			<slot />
		</a>
	{/if}
{/if}
